<template>
  <div class="checkbox">
    <div class="clearfix">
      <input type="checkbox" ref="checkbox" id="agreement" name="agreement" v-validate="'required'" v-model="agreement">
      <label class="label-inline" for="agreement" v-html="labels[termsLabel](links)"></label>
    </div>
    <small v-show="errors.has('agreement')" class="help error">{{ errors.first('agreement') }}</small>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS, VALIDATION_MESSAGES } from '@/settings'

export default {
  inject: ['$validator'],
  data () {
    return {
      agreement: true
    }
  },
  computed: mapState({
    termsLabel: state => state.donation.method === 'stripe' ? 'confirmDataPolicy' : 'confirm',
    links: state => state.donation.method === 'stripe' ? state.termsEn : state.terms,
    lang: state => state.language,
    labels: state => LABELS[state.language]
  }),
  mounted () {
    const lang = this.lang
    this.$validator.localize(lang, VALIDATION_MESSAGES[lang])
  }
}
</script>

<style scoped>
  .oi-donation-form.lang-en label,
  .oi-external-en-form.lang-en label {
    font-size: 11px!important;
  }
  .oi-donation-form .checkbox,
  .oi-external-en-form .checkbox {
    margin-bottom: 10px;
  }
  .oi-donation-form .checkbox input[type="checkbox"],
  .oi-external-en-form .checkbox input[type="checkbox"] {
    opacity: 0;
    position: absolute;
    left: -9999px;
  }

  .oi-donation-form .checkbox label,
  .oi-external-en-form .checkbox label {
    position: relative;
    display: inline-block;
    width: 100%;
    padding-right: 40px;
    font-size: 12px;
    user-select: none;
    cursor: pointer;
    margin: 0;
    text-align: right;
  }

  .oi-donation-form .checkbox label,
  .oi-external-en-form .checkbox label {
    padding: 5px 40px 5px 0;
  }

  /* @media (min-width: 703px) {
    .oi-donation-form.lang-ru .checkbox label::before {
      top: 0px!important;
    }
    .oi-donation-form.lang-ru .checkbox label::after {
      top: 8px!important;
    }
  } */

  @media (max-width: 376px) {
    .oi-donation-form.lang-en .checkbox label,
    .oi-external-en-form.lang-en .checkbox label {
      padding: 0px 40px 5px 0;
    }
  }

  .oi-donation-form .checkbox label::before,
  .oi-external-en-form .checkbox label::before,
  .oi-donation-form .checkbox label::after,
  .oi-external-en-form .checkbox label::after {
    position: absolute;
    content: "";
    display: inline-block;
  }

  .oi-donation-form .checkbox label::before,
  .oi-external-en-form .checkbox label::before {
    height: 30px;
    width: 30px;
    border: 1px solid #d1d1d1;
    background: #fff;
    right: 0px;
    top: 0px;
    border-radius: 3px;
  }

  .oi-donation-form.lang-en .checkbox label::before,
  .oi-external-en-form.lang-en .checkbox label::before {
    top: 0px;
  }

  .oi-donation-form .checkbox label::after,
  .oi-external-en-form .checkbox label::after {
    height: 10px;
    width: 18px;
    border-left: 2px solid;
    border-bottom: 2px solid;
    color: #ef4e23;
    transform: rotate(-45deg);
    right: 5px;
    top: 7px;
  }

  .oi-donation-form.lang-en .checkbox label::after,
  .oi-external-en-form.lang-en .checkbox label::after {
    top: 7px;
  }

  /*Hide the checkmark by default*/
  .oi-donation-form .checkbox input[type="checkbox"] + label::after,
  .oi-external-en-form .checkbox input[type="checkbox"] + label::after {
    content: none;
  }

  /*Unhide on the checked state*/
  .oi-donation-form .checkbox input[type="checkbox"]:checked + label::after,
  .oi-external-en-form .checkbox input[type="checkbox"]:checked + label::after {
    content: "";
  }

  /*Adding focus styles on the outer-box of the fake checkbox*/
  .oi-donation-form .checkbox input[type="checkbox"]:focus + label::before,
  .oi-external-en-form .checkbox input[type="checkbox"]:focus + label::before {
    outline: #ef4e23 auto 5px;
  }
</style>
